import { Module } from 'wrapper6'
import Modalbox from '../utils/_modal-box'

const $ = jQuery

export default class VideoModal extends Module {
  ready (app) {
    new Modalbox('.play-btn')
  }
}
